import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import Checkmark from '../../../../../../../../../Cutesies/Checkmark';
import ShareableLinkIcon from '../../../../../../../../../Cutesies/ShareableLinkIcon';
import Loader from '../../../../../../../../../Loader';

export interface Props {
  kind: 'waiting' | 'copying' | 'copied';
  copying: () => void;
}

function CopyToClipboardState({ kind, copying }: Props) {
  switch (kind) {
    case 'waiting':
      return (
        <span className="flex items-center gap-1">
          <ShareableLinkIcon className="h-4 w-4" />
          <T kind={'Copy Course Link'} />
        </span>
      );
    case 'copying':
      return (
        <div className="">
          <Loader type="spin" text={nothing()} height={24} width={24} color="var(--primary)" />
        </div>
      );
    case 'copied':
      return (
        <div className="flex items-center gap-1">
          <Checkmark className="fill-primary" />
          <T kind={'Copy Course Link'} />
        </div>
      );
  }
}

export default observer(CopyToClipboardState);
